<template>
  <lender-card-layout>
    <template #logo v-if="lender.logo" >
      <div class="boxed-image">
        <img :src="lender.logo" />
      </div>
    </template>

    <template #title>
      <h2>{{ lender.title }}</h2>
    </template>

    <template #score>
      <star-rating
        :rating="lender.scoreAverage"
        :editable="false"
      ></star-rating>

      <span>
        ({{ lender.reviewCount || 0 }} customer review{{ lender.reviewCount === 1 ? '' : 's' }})
      </span>

      <div v-if="lender.discount" class="discount">
        <img :src="discountIcon" />
        <label>LendingWell Benefit</label>
        <span>{{ lender.discount }}</span>
      </div>
    </template>

    <template #description>
      {{ lender.description }}
    </template>

    <template #loanDetails>
      <div>
        <h3>{{ loanInterestRateText }}</h3>
        <p class="subdued">Interest Rate</p>
      </div>
      <div>
        <h3>{{ loanPaymentTermsText }}</h3>
        <p class="subdued">Loan terms</p>
      </div>
      <div>
        <h3>{{ loanTypeText }}</h3>
        <p class="subdued">Loan Type</p>
      </div>
    </template>

    <template #contactButton>
      <button
        v-if="!match.contactedAt"
        :disabled="emailingLender"
        class="default-btn blue"
        @click="emailLender"
      >Email Info to Lender</button>

      <button
        v-else disabled
        class="default-btn green"
      ><span class="mdi mdi-check"></span> Contacted</button>
    </template>

    <template #infoButton>
      <router-link
        class="default-btn blue inverse"
        :to="{ name: 'Lender', params: {
          productId: lender.id,
          dealId,
        }}"
      >See Lender Details</router-link>
    </template>
  </lender-card-layout>
</template>

<script>
import { mapGetters } from 'vuex'

import DiscountIcon from '@/modules/shared/assets/discount_icon.png'

import LenderCardLayout from './LenderCardLayout'

export default {
  name: 'ResultsList',
  components: {
    LenderCardLayout,
  },
  props: {
    dealId: String,
    lender: {
      type: Object,
      default: () => ({}),
    },
    match: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    emailingLender: false,
    discountIcon: DiscountIcon,
  }),

  computed: {
    ...mapGetters('feathers', ['apiMatches']),

    loanInterestRateText () {
      if (this.lender.loanInterestRateCustomDescription) return this.lender.loanInterestRateCustomDescription

      const text = this.lender.loanInterestRate || this.lender.loan_interest_rate
      return text
        ? text + '%'
        : ''
    },

    loanPaymentTermsText () {
      if (this.lender.loanPaymentTermsCustomDescription) return this.lender.loanPaymentTermsCustomDescription

      return this.lender.loanPaymentTerms || this.lender.loan_payment_terms || ''
    },

    loanTypeText () {
      if (this.lender.loanTypeCustomDescription) return this.lender.loanTypeCustomDescription

      const type = this.lender.loanType
      if (!type) return 'No Preference'
      if (type === 'Conv') return 'Conventional Loan'

      return type
    },
  },
  methods: {
    async emailLender () {
      this.emailingLender = true

      try {
        await this.apiMatches.patch(this.match.id, {
          contactedAt: Date.now(),
        })

        this.match.contactedAt = Date.now()

        this.addAlert({
          type: 'success',
          message: 'Successfully sent a contact email!',
        })
      } catch (err) {
        this.addAlert({
          type: 'error',
          message: `There was an issue when attempting to contact lender: ${err.message}`,
        })
      }

      this.emailingLender = false
    },
  },
}
</script>

<style lang="scss" scoped>
h2 {
  color: $textDarkMuted;
}

.results-list-container {
  padding-bottom: 100px;
}

.match-item-wrapper {
  & > *:last-child {
    padding-left: 64px;

    display: flex;
    flex-direction: column;

    & > div {
      margin-top: 28px;

      display: flex;
      justify-content: flex-start;
    }
  }
}
</style>
